// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import audioReducer from './redux.audioSlice.js';

const store = configureStore({
  reducer: {
    audio: audioReducer,
  },
});

export default store;

